export default {
	SAVE_BROADCAST_MESSAGE: "broadcast_message/SAVE_BROADCAST_MESSAGE"
}
